import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";
import { useAgentsEnabledFlag } from "src/pages/agents/hooks/use-agents-enabled-flag";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";

export function useIsContextHubEnabled(): boolean {
  const isAdStudioEnabled = useIsAdStudioEnabled();
  const isAgentsEnabled = useAgentsEnabledFlag();
  const isLifecycleStudioEnabled = useLifecycleStudioEnabled();
  return isAdStudioEnabled || isAgentsEnabled || isLifecycleStudioEnabled;
}
